// Automatically generated from TW.Saga.Shared.MetadataLib, Version=1.0.0.0, Culture=neutral, PublicKeyToken=null @19.06.2017 18:53:46
import { Color } from '@models/color';
import { ListResourceStatus_abstract } from './../abstract/SagaStateLib/ListResourceStatus_abstract';

export class ListResourceStatus extends ListResourceStatus_abstract {
  private _color: Color;
  private _oColor: Color;

  get color(): Color {
    if (!this._color) {
      this._color = new Color(this.FColor);
    }
    return this._color;
  }

  get oColor(): Color {
    if (!this._oColor) {
      this._oColor = new Color(this.OFColor);
    }
    return this._oColor;
  }

  get displayColor(): string {
    return this.color.toRgbString();
  }
}
